// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hvyYt","content":"styles_content__2jFTx"};